import { canCreateEmailComposition, getPotentialFroms } from './create_email_composition';
import CreateComposition from './lib/create_composition';
import nextDay from 'scripts/lib/next_day';
import ThirdPartyEmailCompositionContent from 'models/composition/third_party_email_composition_content';

class CreateThirdPartyEmailComposition extends CreateComposition {
  constructor(context) {
    super(context, ThirdPartyEmailCompositionContent);
  }

  // The task that holds the thread lands in the conversation's inbox, so the mail should leave from
  // that inbox's address too: replies route back by it.
  _createContent({ conversation }) {
    const froms = getPotentialFroms(this.context, conversation);
    return new ThirdPartyEmailCompositionContent({
      dueAt: nextDay(),
      from: froms.default || froms.preferred[0] || froms.all[0] || '',
      to: '',
    });
  }

  _canCreateComposition() {
    return canCreateEmailComposition(this.context);
  }
}

export default CreateThirdPartyEmailComposition;
